import api from 'infra/api';

export default async function getFilters() {
  return api()
    .url('/drivers/v2/offer_list/filters/')
    .get()
    .json();
}
